import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const ERROR_MESSAGES = {
	NO_DROPDOWNS: 'Dropdowns: No dropdown elements found',
	MISSING_ELEMENTS: 'Dropdowns: Missing required elements in dropdown',
	INIT_FAILED: 'Dropdowns: Initialization failed',
};

const CONFIG = {
	CLASSES: {
		ACTIVE: 'active',
		SHOW: 'show',
	},
	SELECTORS: {
		DROPDOWN: '.dropdown',
		TOGGLE: '.dropdown-toggle',
		MENU: '.dropdown-menu',
		NAV_ITEM: '.nav-item',
	},
	EVENTS: {
		MOUSE_ENTER: 'mouseenter',
		MOUSE_LEAVE: 'mouseleave',
		CLICK: 'click',
		KEYDOWN: 'keydown',
	},
	KEYS: {
		ESCAPE: 'Escape',
	},
};

/**
 * Initialize dropdown functionality
 * @returns {void}
 */
const initializeDropdowns = () => {
	document.querySelectorAll('.custom-mobile-accordion-link').forEach(link => {
		link.addEventListener('click', function (e) {
			const iconWidth = 48;
			const rect = this.getBoundingClientRect();

			const clickedIcon =
				e.clientX >= rect.right - iconWidth;

			if (clickedIcon) {
				e.preventDefault();

				const target = document.querySelector(
					this.dataset.bsTarget
				);

				const collapse = bootstrap.Collapse.getOrCreateInstance(target);

				if (target.classList.contains('show')) {
					collapse.hide();
					link.classList.add('collapsed');
				} else {
					document.querySelectorAll('.custom-mobile-accordion-link')
						.forEach(el => el.classList.add('collapsed'));
					collapse.show();
					link.classList.remove('collapsed');
				}
			}
			else{
				if(link.getAttribute('data-link')){
					window.location.href = link.getAttribute('data-link');
				}
			}
		});
	});
	const dropdowns = document.querySelectorAll(CONFIG.SELECTORS.DROPDOWN);
	if (!dropdowns.length) {
		console.warn(ERROR_MESSAGES.NO_DROPDOWNS);
		return;
	}

	try {
		dropdowns.forEach((dropdown) => {
			const button = dropdown.querySelector(CONFIG.SELECTORS.TOGGLE);
			const menu = dropdown.querySelector(CONFIG.SELECTORS.MENU);

			if (!button || !menu) {
				console.warn(ERROR_MESSAGES.MISSING_ELEMENTS, dropdown);
				return;
			}

			/**
			 * Handle mouse enter event for nav items
			 * @returns {void}
			 */
			const handleMouseEnter = () => {
				dropdowns.forEach((otherDropdown) => {
					if (otherDropdown !== dropdown && otherDropdown.classList.contains(CONFIG.SELECTORS.TOGGLE)) {
						const otherDropdownMenu = new bootstrap.Dropdown(otherDropdown.querySelector(CONFIG.SELECTORS.TOGGLE));
						otherDropdownMenu.hide();
					}
				});

				const dropdownMenu = new bootstrap.Dropdown(button);
				dropdownMenu.show();
			};

			/**
			 * Handle mouse leave event for nav items
			 * @returns {void}
			 */
			const handleMouseLeave = () => {
				const dropdownMenu = new bootstrap.Dropdown(button);
				dropdownMenu.hide();
			};

			/**
			 * Handle click event for dropdown toggle
			 * @param {Event} e - The click event
			 * @returns {void}
			 */
			const handleClick = (e) => {
				if(!e.currentTarget.classList.contains('simple-menu-dropdown')){
					e.stopPropagation();
				}
				const isActive = dropdown.classList.contains(CONFIG.CLASSES.ACTIVE);

				dropdowns.forEach((d) => d.classList.remove(CONFIG.CLASSES.ACTIVE));

				dropdown.classList.toggle(CONFIG.CLASSES.ACTIVE, !isActive);
			};

			/**
			 * Handle document click event
			 * @param {Event} e - The click event
			 * @returns {void}
			 */
			const handleDocumentClick = (e) => {
				if (!dropdown.contains(e.target)) {
					dropdown.classList.remove(CONFIG.CLASSES.ACTIVE);
					const dropdownMenu = new bootstrap.Dropdown(button);
					dropdownMenu.hide();
				}
			};

			/**
			 * Handle keydown event
			 * @param {KeyboardEvent} e - The keydown event
			 * @returns {void}
			 */
			const handleKeydown = (e) => {
				if (e.key === CONFIG.KEYS.ESCAPE && (dropdown.classList.contains(CONFIG.CLASSES.ACTIVE) || menu.classList.contains(CONFIG.CLASSES.SHOW))) {
					dropdown.classList.remove(CONFIG.CLASSES.ACTIVE);
					const dropdownMenu = new bootstrap.Dropdown(button);
					dropdownMenu.hide();
					button.focus();
				}
			};

			if (dropdown.classList.contains(CONFIG.SELECTORS.NAV_ITEM.slice(1))) {
				dropdown.addEventListener(CONFIG.EVENTS.MOUSE_ENTER, handleMouseEnter);
				dropdown.addEventListener(CONFIG.EVENTS.MOUSE_LEAVE, handleMouseLeave);
			}

			button.addEventListener(CONFIG.EVENTS.CLICK, handleClick);
			document.addEventListener(CONFIG.EVENTS.CLICK, handleDocumentClick);
			document.addEventListener(CONFIG.EVENTS.KEYDOWN, handleKeydown);
		});
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeDropdowns };
